import labelsLayerInstance from "../../app/labelsLayerInstance";
import interpolator from "../../app/interpolator";
import store from "../../app/store"
import overlays from "../../app/overlays";
import format from "../../app/format";
import utils from "../../app/utils";
import PoiLabels from "./PoiLabels";
import layers from "../../app/layers";


/**
 * Clase que extiende PoiLabels y se especializa en la visualización de los valores de las variables sobre el mapa.
 */
class VariablesLabels extends PoiLabels{
    /**
     * Crea una instancia de VariablesLabels.
     * @constructor
     */
    constructor(empty) {
        super();
        // if (empty)
        //     this.empty = true;
    }

    /**
     * Inicializa las propiedades de la instancia.
     * @override
     */
    initProperties(){
        super.initProperties();
        this.ident = "cities";
        this.pluginIdent = "detail";
        this.minZoom = 5;
        // this.empty = false;
        this.popupOffset = [20, -15];
    }

    /**
     * Desactiva la capa de etiquetas de los valores de las variables.
     * @override
     */
    deactivate (){
        super.deactivate();
        labelsLayerInstance.updateLabels();
    }

    /**
     * Descarga los datos de etiquetas de los valores de las variables.
     * @override
     */
    download(){
        const variablesLabels = this;

        interpolator(
            function(interpolateFunc) {
                variablesLabels.interpolate = interpolateFunc.bind(interpolator);
                variablesLabels.ovrIdent = store.get("overlay");
                variablesLabels.overlay = overlays[variablesLabels.ovrIdent];
                variablesLabels.lastUrl = null;

                if (variablesLabels.overlay.poiInCities) {
                    const dataArrayPromise = variablesLabels.getDataArray();
                    dataArrayPromise.then((dataArray)=>{variablesLabels.onloaded(variablesLabels.syncCounter, dataArray)});
                } else
                    variablesLabels.delete();
            }
        );
    }

    /**
     * Callback para el manejo de datos cargados.
     * @param {number} syncCounter - Contador de sincronización.
     * @param {Object} dataArray - Array con las etiquetas del mapa .
     */
    onloaded(syncCounter, dataArray){
        const id = dataArray.id;

        if (null !== id && void 0 !== id && id.length && syncCounter === this.syncCounter) {
            // Datos de las etiquetas del mapa
            this.data = dataArray;
            // función Dirección viento?
            this.formatDir = format.getDirFunction();

            const zoom = this.map.getZoom();
            // Si se cambia de zoom
            if (this.prevZoom !== zoom) {
                this.deleteNonVisible();
                this.prevZoom = zoom
            }

            this.render();
        }

    }


    /**
     * Elimina las etiquetas de valores de las variables no visibles en el mapa.
     * @private
     */
    deleteNonVisible(){
        let arrayIds = {};
        if (this.data) {
            // Marcamos a true todos los ids contenidos en data
            for (let index = 0; index < this.data.id.length; index++)
                arrayIds[this.data.id[index]] = true;

            // Se borran los markers con ids no contenidos en data
            for (let marker in this.markers)
                if ( ! marker in arrayIds)
                    this.deleteMarker(marker);
        }

    }


    /**
     * Obtiene un array de datos con las etiquetas de ciudad dentro de los límites del mapa.
     * @returns {Object} - Datos de las ciudades.
     */
    async getDataArray() {
        let labelsArray = await labelsLayerInstance.toArray(),
            bounds = this.map.getBounds(),
            north = bounds.getNorth(),
            east = bounds.getEast(),
            south = bounds.getSouth(),
            west = bounds.getWest(),
            array = {
                element: [],
                id: [],
                isFavorite: [],
                lat: [],
                lon: [],
                title: []
            }, insideBounds = function(lat, lon) {
                return lon > west && lon < east && lat < north && lat > south
            };

        for (let index = 0; index < labelsArray.length; index++) {
            const label = labelsArray[index]
                , id = label.id
                , element = label.el
                // , u = id.split("/")
                , lat = label.lat
                , lon = label.lon;
            // if(insideBounds(+lat, +lon)) {
                array.id.push(id);
                array.lat.push(+lat);
                array.lon.push(+lon);
                array.isFavorite.push(false);
                array.title.push(null);
                array.element.push(element)
            // }
        }

        // const f = favs.getAll();
        // for (let g in f) {
        //     let y = f[g]
        //         , b = y.lat
        //         , z = y.lon
        //         , w = y.title;
        //     if (insideBounds(+b, +z)){
        //         a.id.push(g);
        //         a.lat.push(+b);
        //         a.lon.push(+z);
        //         a.isFavorite.push(true);
        //         a.title.push(w);
        //         a.element.push(null);
        //     }
        // }
        return array
    }

    /**
     * Renderiza las etiquetas de los valores de las variables en el mapa.
     * @param {Event} [event] - Evento de zoom.
     */
    render(event){
        let o = "";
        if (event && "zoomend" !== event.type && this.data || !event && this.data) {
            for (let index = 0; index < this.data.id.length; index++) {
                let id = this.data.id[index]
                    , lat = this.data.lat[index]
                    , lon = this.data.lon[index]
                    , isFavorite = this.data.isFavorite[index]
                    , title = this.data.title[index]
                    , element = this.data.element[index];

                if (id) {
                    let coords = {
                        lat: lat,
                        lon: lon
                    }, value, payload = null;

                    // if (! this.empty) {
                    value = this.interpolate(coords)
                    payload = this.getPayload(value);
                    // }
                    if (isFavorite && title)
                        o += this.displayFav(id, coords, title, payload)
                    else if (element)
                        this.displayCity(id, payload, element);
                }
            }
            this.layer.addPois(o, this.markers);
        }
    }


    /**
     * Verifica si un objeto tiene un payload válido.
     * @param {*} object - Objeto a verificar.
     * @returns {boolean} - true si tiene un payload válido, false en caso contrario.
     */
    hasPayload(object) {
        return Boolean(object && (object.html || object.attrs))
    }


    /**
     * Muestra una etiqueta de valor de una variable sobre una ciudad en el mapa.
     * @param {string} id - Identificador de la ciudad.
     * @param {Object} payload - Datos de la variable de la ciudad.
     * @param {HTMLElement} element - Elemento HTML de la etiqueta.
     */
    displayCity(id, payload, element) {
        let label;

        if (this.hasPayload(payload)/* && "temp" !== store.get("overlay")*/)
            element.innerHTML = "".concat(element.dataset.label, '<div class="label-wx" ').concat(payload.attrs ? payload.attrs.join(" ") : "", ">").concat(payload.html || "", "</div>")
        else {
            label = element.dataset.label
            element.innerHTML = null !== label ? label : "";
        }
    }


    displayFav(t, o, i, e) {
        let s;
        if (this.hasPayload(e)) {
            if(e.attrs)
                e.attrs.push('data-text="'.concat(name, '"'));
            const latLng = L.latLng(o.lat, o.lon);
            s = this.layer.getHtml(t, latLng, e);
        }

        if (t in this.markers){
            if (s)
                this.layer.replaceMarker(t, s);
            else
                this.deleteMarker(t);
            return "";
        }else{
            if (s){
                this.markers[t] = L.latLng(o.lat, o.lon);
                return s;
            }else
                return "";

        }

        // return t in this.markers ? (s ? this.layer.replaceMarker(t, s) : this.deleteMarker(t),
        //     "") : s ? (this.markers[t] = L.latLng(o.lat, o.lon),
        //     s) : ""
    }


    /**
     * Obtiene el payload (un objeto con el html, estilo y atributos que se pintan debajo de la ciudad) para unos valores específico.
     * @param {*} values - Valores para los que se obtiene el payload.
     * @returns {*} - Payload correspondiente al valor.
     */
    getPayload(values) {

        if (! values || "number" == typeof values && values < 0 || !Array.isArray(values) || this.overlay.hideWxLabels)
            return null;

        const defaultValue = this.overlay.getDefaultValue(values);

        // Trata los casos especificos
        switch (this.ovrIdent) {
            case "prcnub":
                return this.wx2html(values);
            case "viento":
            case "ivt":
                return this.wx2html(utils.wind2obj(values));
            // case "ptype":
            //     return t[0] < .1 ? null : this.wx2html(t[1]);
            case "duaod550":
                if (defaultValue < 0.002)
                    return null;
                break;
            case "radar":
                // if (defaultValue < 10)
                    return null;
                // break;
            case "acumprec":
            case "acumnieve":
            case "precip":
            case "nieve":
                if (defaultValue < .2)
                    return null
        }
        // Por defeto devuelve el html para defaultValue
        return this.wx2html(defaultValue);
    }


    /**
     * Convierte datos meteorológicos a formato HTML.
     * @param {*} values - Datos meteorológicos a convertir.
     * @returns {Object|null} - Objeto con formato HTML o null si no hay datos.
     */
    wx2html(values) {
        // Si el overlay es vectorial se utiliza el calculo del módulo de los dos vectores
        if ("viento" === this.ovrIdent || "ivt" === this.ovrIdent) {
            let value = Math.round(overlays[this.ovrIdent].convertNumber.call(overlays[this.ovrIdent].m, values.wind)) // + (t.gust ? ", g:" + Math.round(overlays.wind.convertNumber.call(overlays.wind.m, t.gust)) : "")
                // , html = utils.windDir2html(values)
                , attrs = [`data-value="${value}"`];
            // if (html)
            //     attrs.push('class="poi-has-wind poi-point"');
            return  {
                    // style: "background-color: ".concat(this.overlay.c.colorDark(values.wind, 20), ";"),
                    attrs: attrs,
                    // html: html
                }
        }

        // Si el overlay el prcnub se pinta tanto la lluvia como la nieve
        if (this.ovrIdent === "prcnub"){
            let metricprec, metricnieve,
                convertedValue,
                layerPrecip = layers["precip"],
                layerNieve = layers["nieve"];

            metricprec = layerPrecip.m;
            metricnieve = layerNieve.m;

            convertedValue = metricprec.convertNumber(values[1] - values[2]);


            let precstr= "";
            let nievestr ="";
            if (values[1] - values[2] >= 0.2) {
                precstr = `<div class="iconcityfont" data-do=\"changeMetric\">&#xe805;</div>${convertedValue}`
            }

            convertedValue = metricnieve.convertNumber(values[2]);

            if (values[2] >= 0.2) {
                let separator = "";
                if (precstr !== "")
                    separator= "separator";
                nievestr = `<div class="iconcityfont ${separator}" data-do=\"changeMetric\">&#xe832;</div>${convertedValue}`
            }

            const html = precstr + nievestr;

            if (html === "")
                return null;

            return  {
                // style: "background-color: ".concat(this.overlay.c.colorDark(t.wind, 20), ";"),
                // attrs: "",
                html: html
            }

        }

        // Resto de casos
        if ("number" == typeof values) {
            let n, convertedValue;
            switch (this.ovrIdent) {
                case "nubes":
                case "prob":
                case "humedad":
                    n = Math.floor(values) + "%";
                    break;
                case "temp2m":
                case "atemp":
                // case "dewpoint":
                    convertedValue = this.overlay.convertNumber(values);
                    n = "".concat(convertedValue, "°");
                    if (this.ovrIdent === "atemp" && convertedValue > 0)
                        n = "+"+n;
                    break;
                default:
                    n = "".concat(this.overlay.convertNumber(values));
            }
            return {
                style: "background-color:".concat(this.overlay.c.colorDark(values, 20)),
                attrs: ['data-value="'.concat(n, '"')]
            }
        }
        return {}
    }

    /**
     * Redibuja las etiquetas de los valores de las variables en el mapa.
     */
    redraw() {
        const t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.cancel();
        if(t)
            this.delete();
        this.download();
    }


}


export default VariablesLabels;
